/*
    Created on : 3-set-2018
    Author     : Mauro Nascimbene
 * 
 *  id_cliente
 *  datiutente --> dati dell'utente
 *  datainfosocieta --> risposta del configurazioni della societa'
 *  datainfo --> risposta del configurazioni del singolo cliente
 *  siti --> elenco SITI caricati probabilmente dalla HOME
 *  
 *  filterdatada ( filtro fatture )
 *  filterdataa  ( filtro fatture )
 *  
 *  filterdataregda ( filtro registri )
 *  filterdatarega  ( filtro registri )
 *  
 *  maschera
 */

import * as React from 'react';

export class Session extends React.Component  {
  set(id, value) {
    if (typeof value === 'object') value = JSON.stringify(value);
    sessionStorage.setItem(id, value);
  }

  get(id) {
    const value = sessionStorage.getItem(id);
    try { return JSON.parse(value); } 
    catch (e) { return value; }
  }
  
  remove(id) { sessionStorage.removeItem(id); }
  
  clear() { sessionStorage.clear(); }
}

export default Session;


// WEBPACK FOOTER //
// ./src/AcComponents/classi/Session.js